import { render, staticRenderFns } from "./c_sorgu_list.vue?vue&type=template&id=32e35776"
import script from "./c_sorgu_list.vue?vue&type=script&lang=js"
export * from "./c_sorgu_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports